import { SET_GIFT_EXCHANGE_POINT_ACTION } from "../actions/GiftExchangePageAction/actionTypes";

const initialState = {
	giftExchangePoint: {}
};

const giftExchangePageReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_GIFT_EXCHANGE_POINT_ACTION: {
			return {
				...state,
				giftExchangePoint: action.params.data
			};
		}
		default:
			return state;
	}
};

export default giftExchangePageReducer;
